import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth.tsx";
import type { ReactNode } from "react";

// Wrap admin pages with this — if no auth, redirect to /login and remember
// the intended destination so we can return after a successful login.
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
